import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NewCustomWeekPage } from './new-custom-week';
import { SharedModule } from '../../../shared';
import { TranslateModule } from '@ngx-translate/core';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    NewCustomWeekPage
  ],
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild([{ path: '', component: NewCustomWeekPage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ]
})
export class NewCustomWeekPageModule {}
